import { versionedHttpCollection } from "us.helper/http/collection";

export const duplicateDebtors = {
  search: async ({ debtorId }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `debtor/duplicates/${debtorId}`,
          {},
          "v1"
        );
        if (status == 200) {
          resolve({ data, status });
        } else {
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  merge: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "entityservice",
          `debtor/duplicates`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  getHistory: async ({ debtorId }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `debtor/duplicates/history/${debtorId}`,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
};
